import { render, staticRenderFns } from "./ChipFilter.vue?vue&type=template&id=126f6e38&lang=pug&"
import script from "./ChipFilter.vue?vue&type=script&lang=js&"
export * from "./ChipFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VSwitch})
